import React from 'react';
import Joi from 'joi';
import _ from 'lodash';

import Form from '../common/form';
import Progress from '../themed/progress';

import withCountries from '../hoc/withCountries';
import withOrganizations from '../hoc/withOrganizations';

import * as facilityService from '../../services/facilityService';
import * as toastService from '../../services/toastService';

import * as models from '../../utils/models';
import * as utils from '../../utils/utilities';

import routes from '../../utils/routes';

class CreateFacility extends Form {
	state = {
		data: {
			facilityLogo: [],
			facilityName: '',
			organisationId: '',
			country: '',
		},
		errors: {},
		loading: false,
		progress: 0,
		organizations: [],
	};

	schema = {
		facilityLogo: Joi.array().min(1).required().label('Facility Logo'),
		organisationId: Joi.string().min(3).required().label('Organization'),
		facilityName: Joi.string().min(3).required().label('Facility Name'),
		country: Joi.string().min(3).required().label('Country'),
	};

	getApiData = () => {
		const { data } = this.state;
		const { facilityName, organisationId } = data;

		const apiData = { facilityName, organisationId } as any;

		apiData.facilityLocation = _.pick(data, ['country']);
		apiData.facilityLogo = (data.facilityLogo[0] as models.PDFImageProps).src;

		return apiData;
	};

	postData = async (): Promise<void> => {
		const apiData = this.getApiData();

		await facilityService.createFacility(apiData, this.handleProgressChange);
		window.location.href = routes.organizations.fullPath;
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Creating Facility',
			success: 'Facility Created',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
					<h1 className="form-title">Create a New Facility</h1>

					{this.renderFileInput({
						max: 1,
						multiple: false,
						name: 'facilityLogo',
						accept: 'image/*,application/pdf',
						label: 'Facility Logo',
						sublabel: 'Upload Facility Logo',
						types: utils.getFileUploadTypes(),
					})}

					<div className="divider my-4"></div>

					<div className="row mt-2">
						<div className="col">
							{this.renderSelect({
								name: 'organisationId',
								label: 'Organization',
								placeholder: 'Select an Organization',
								options: this.props.organizationsForDropdown,
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'facilityName',
								label: 'Facility Name',
								placeholder: 'Enter Facility Name',
							})}
						</div>
					</div>

					<div className="row mt-2">
						<div className="col">
							{this.renderSelect({
								name: 'country',
								label: 'Country',
								placeholder: 'Select Country',
								options: this.props.countries,
							})}
						</div>
					</div>

					<div className="d-flex justify-content-end">
						{this.renderButton('Create')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default withOrganizations(withCountries(CreateFacility));
